import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogDataModel } from '../../models/dialog.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'igx-dialog-buttons',
  imports: [ButtonModule, DialogModule, TranslatePipe],
  templateUrl: './dialog-buttons.component.html',
  styleUrl: './dialog-buttons.component.scss',
})
export class DialogButtonsComponent {
  public readonly _dialogRef = inject(DynamicDialogRef);
  private readonly _dialogConfig = inject(DynamicDialogConfig);
  private readonly _dialogData = this._dialogConfig.data as DialogDataModel;

  public onCancel(): void {
    this._dialogData?.onCancel?.();
  }

  public onSubmit(): void {
    this._dialogData?.onSubmit?.();
  }
}
